import type { IconData } from '@stacksjs/iconify-core'

export const shoppingShippingCrack2: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M22.86 3.805h1.52v9.15h-1.52Zm-1.52 22.86h1.52v3.05h-1.52Zm0-13.71h1.52v3.04h-1.52Zm-1.53 3.04h1.53v1.53h-1.53Zm-9.14 13.72h10.67v1.52H10.67Z\"/><path fill=\"currentColor\" d=\"M12.19 17.525v1.52h3.05v6.1h-4.57v1.52h4.57v1.53h1.52v-1.53h4.58v-1.52h-4.58v-6.1h3.05v-1.52zm7.62-13.72v-1.52h1.53V.765h-4.58v1.52h-1.52v1.52h-1.52v1.53h-1.53v1.52h3.05v1.53h-1.52v1.52h-1.53v1.52h3.05v-1.52h1.52v-1.52h1.53v-1.53h1.52v-1.52h-1.52v-1.53zm-9.14 12.19h1.52v1.53h-1.52ZM9.15 2.285h3.04v1.52H9.15Zm0 24.38h1.52v3.05H9.15Zm0-13.71h1.52v3.04H9.15Zm-1.53-9.15h1.53v9.15H7.62Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default shoppingShippingCrack2
